var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningExclamationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#FEF5E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0002 20C63.4615 20 76.0003 32.5388 76.0003 48.0002C76.0003 63.4615 63.4615 76.0003 48.0002 76.0003C32.5388 76.0003 20 63.4615 20 48.0002C20 32.5388 32.5388 20 48.0002 20ZM45.0004 50.4096V35.9983C45.0004 34.3461 46.3481 32.9985 48.0002 32.9985C49.6523 32.9985 50.9999 34.3587 50.9999 35.9983V50.4096C50.9999 52.0492 49.6523 53.4094 48.0002 53.4094C46.348 53.4094 45.0004 52.0617 45.0004 50.4096ZM47.9872 56.6267C49.8647 56.6267 51.3873 58.1494 51.3873 60.0266C51.3873 61.9041 49.8647 63.4268 47.9872 63.4268C46.11 63.4268 44.5873 61.9041 44.5873 60.0266C44.5873 58.1494 46.11 56.6267 47.9872 56.6267Z",
    fill: "#F79B0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningExclamationCircle);
export default __webpack_public_path__ + "static/media/warning-exclamation-circle.835107a220343c073cb3e867b5525c77.svg";
export { ForwardRef as ReactComponent };